import React from 'react'
import { Link } from 'react-router-dom'

class DisabledBigButtonComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <Link style={styles.link} to={this.props.link}>
          <button
            style={styles.button}
            onClick={() => this.props.onClick()}>
            <span style={styles.label}>{this.props.label}</span>
            <img
              style={styles.icon}
              src={this.props.img}
              alt='true'
            />
          </button>
        </Link>
      </div>
    )
  }
}

const styles = {
  link: {
    textDecoration: 'none'
  },
  buttonContent: {
    marginTop: '8px',
    float: 'right',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: '146px',
    height: '26px',
    marginLeft: '12px',
    border: '1px solid #A6B9C8',
    borderRadius: '10px',
    backgroundColor: '#16191C'
  },
  label: {
    textAlign: 'center',
    color: '#A6B9C8',
    fontSize: '10px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  icon: {
    float: 'right'
  }
}

export default DisabledBigButtonComponent
